import React from 'react';

interface ProductDiscountProps {
  appliedDiscounts: Array<{
    id: number;
    code: string;
    name: string;
    category: string;
    discountAmount: number;
    discountType: string;
    value: number;
    description: string;
    combinable: boolean;
    combineWithProductDiscounts: boolean;
    combineWithOrderDiscounts: boolean;
    combineWithShippingDiscounts: boolean;
    isAutomatic: boolean;
    appliedAt: string;
  }>;
  currency: string;
}

const ProductDiscount: React.FC<ProductDiscountProps> = () => {
  // Hide coupon labels in product list when new coupon is applied
  return null;
};

export default ProductDiscount; 